(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["CategorizedTagInput"] = factory(require("react"));
	else
		root["CategorizedTagInput"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _CategorizedTagInputJsx = __webpack_require__(3);
	
	var _CategorizedTagInputJsx2 = _interopRequireDefault(_CategorizedTagInputJsx);

	exports['default'] = _CategorizedTagInputJsx2['default'];
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var PropTypes = _react2['default'].PropTypes;
	
	var Tag = _react2['default'].createClass({
	  displayName: 'Tag',
	
	  propTypes: {
	    selected: PropTypes.bool,
	    input: PropTypes.string.isRequired,
	    text: PropTypes.string.isRequired,
	    addable: PropTypes.bool,
	    deletable: PropTypes.bool,
	    onAdd: PropTypes.func,
	    onDelete: PropTypes.func,
	    style: PropTypes.object
	  },
	
	  // helps tests pass
	  getDefaultProps: function getDefaultProps() {
	    return {
	      text: ''
	    };
	  },
	
	  tagContent: function tagContent() {
	    var content = [];
	    var startIndex = this.props.text.trim().toLowerCase().indexOf(this.props.input.trim().toLowerCase());
	    var endIndex = startIndex + this.props.input.length;
	
	    if (startIndex > 0) {
	      content.push(_react2['default'].createElement(
	        'span',
	        { key: 1, className: 'cti__tag__content--regular' },
	        this.props.text.substring(0, startIndex)
	      ));
	    }
	
	    content.push(_react2['default'].createElement(
	      'span',
	      { key: 2, className: 'cti__tag__content--match' },
	      this.props.text.substring(startIndex, endIndex)
	    ));
	
	    if (endIndex < this.props.text.length) {
	      content.push(_react2['default'].createElement(
	        'span',
	        { key: 3, className: 'cti__tag__content--regular' },
	        this.props.text.substring(endIndex)
	      ));
	    }
	
	    return content;
	  },
	
	  onClick: function onClick(e) {
	    e.preventDefault();
	    if (this.props.addable) {
	      this.props.onAdd(e);
	    }
	  },
	
	  onDelete: function onDelete(e) {
	    // Prevents onClick event of the whole tag from being triggered
	    e.preventDefault();
	    e.stopPropagation();
	    this.props.onDelete(e);
	  },
	
	  getDeleteBtn: function getDeleteBtn() {
	    var style = this.props.style || {};
	    var deleteStyle = style['delete'] ? style['delete'] : {};
	
	    return _react2['default'].createElement('span', { className: 'cti__tag__delete', onClick: this.onDelete,
	      dangerouslySetInnerHTML: { __html: '&times;' },
	      style: deleteStyle });
	  },
	
	  render: function render() {
	    var deleteBtn = null;
	    if (this.props.deletable) {
	      deleteBtn = this.getDeleteBtn();
	    }
	    var cls = 'cti__tag' + (this.props.selected ? ' cti-selected' : '');
	
	    var style = this.props.style || {};
	
	    return _react2['default'].createElement(
	      'div',
	      { className: cls, onClick: this.onClick, style: style.base || {} },
	      _react2['default'].createElement(
	        'div',
	        { className: 'cti__tag__content', style: style.content || {} },
	        this.tagContent()
	      ),
	      deleteBtn
	    );
	  }
	});
	
	exports['default'] = Tag;
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.isCategoryItemValid = isCategoryItemValid;
	exports.isCategoryValid = isCategoryValid;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputJsx = __webpack_require__(5);
	
	var _InputJsx2 = _interopRequireDefault(_InputJsx);
	
	var _PanelJsx = __webpack_require__(6);
	
	var _PanelJsx2 = _interopRequireDefault(_PanelJsx);
	
	var _keyboard = __webpack_require__(7);
	
	var key = _interopRequireWildcard(_keyboard);
	
	var PropTypes = _react2['default'].PropTypes;
	
	function isCategoryItemValid(i) {
	  return typeof i === 'string' && i.trim().length > 0;
	}
	
	function isCategoryValid(c) {
	  return typeof c === 'object' && c.id && c.title && c.items && Array.isArray(c.items) && c.items.every(isCategoryItemValid) && (c.type || c.single);
	}
	
	var CategorizedTagInput = _react2['default'].createClass({
	  displayName: 'CategorizedTagInput',
	
	  propTypes: {
	    addNew: PropTypes.bool,
	    categories: PropTypes.arrayOf(PropTypes.object).isRequired,
	    transformTag: PropTypes.func,
	    value: PropTypes.arrayOf(PropTypes.object),
	    onBlur: PropTypes.func,
	    onChange: PropTypes.func,
	    placeholder: PropTypes.string,
	    getTagStyle: PropTypes.func,
	    getCreateNewText: PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      value: '',
	      selection: {
	        item: 0,
	        category: 0
	      },
	      panelOpened: false,
	      categories: [],
	      addNew: this.props.addNew === undefined ? true : this.props.addNew
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onChange: function onChange(newTags) {
	        // do nothing
	      }
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    if (!this.props.categories.every(isCategoryValid)) {
	      throw new Error('invalid categories source provided for react-categorized-tag-input');
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	  },
	
	  filterCategories: function filterCategories(input) {
	    var _this = this;
	
	    var categories = this.props.categories.map(function (c) {
	      c = Object.assign({}, c, {
	        items: c.items.filter(_this.filterItems(input))
	      });
	      return c.items.length === 0 && (!_this.state.addNew || c.single) ? null : c;
	    }).filter(function (c) {
	      return c !== null;
	    });
	
	    var selection = this.state.selection;
	    if (this.state.selection.category >= categories.length) {
	      selection = {
	        category: 0,
	        item: 0
	      };
	    } else {
	      if (selection.item >= categories[selection.category].items.length) {
	        selection.item = 0;
	      }
	    }
	
	    this.setState({
	      categories: categories,
	      selection: selection
	    });
	  },
	
	  filterItems: function filterItems(input) {
	    return function (i) {
	      if (input.length === 1) {
	        return i.toLowerCase().trim() === input;
	      }
	      return i.toLowerCase().indexOf(input.trim().toLowerCase()) >= 0;
	    };
	  },
	
	  openPanel: function openPanel() {
	    this.setState({ panelOpened: true });
	  },
	
	  closePanel: function closePanel() {
	    var _this2 = this;
	
	    // Prevent the panel from hiding before the click action takes place
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.timeout = setTimeout(function () {
	      _this2.timeout = undefined;
	      _this2.setState({ panelOpened: false });
	    }, 150);
	  },
	
	  onValueChange: function onValueChange(e) {
	    var value = e.target.value;
	    this.setState({ value: value, panelOpened: value.trim().length > 0 || !isNaN(Number(value.trim())) });
	    this.filterCategories(value);
	  },
	
	  onTagDeleted: function onTagDeleted(i) {
	    var newTags = this.props.value.slice();
	    newTags.splice(i, 1);
	    this.props.onChange(newTags);
	  },
	
	  onAdd: function onAdd(newTag) {
	    var newTags = this.props.value.concat([newTag]);
	    this.setState({
	      value: '',
	      panelOpened: true
	    });
	
	    this.refs.input.focusInput();
	    this.props.onChange(newTags);
	  },
	
	  addSelectedTag: function addSelectedTag() {
	    if (!(this.state.panelOpened && this.state.value.length > 0)) {
	      return;
	    }
	
	    var category = this.state.categories[this.state.selection.category];
	    var title = category.items[this.state.selection.item];
	    this.onAdd({
	      category: category.id,
	      title: title || this.state.value
	    });
	  },
	
	  handleBackspace: function handleBackspace(e) {
	    if (this.state.value.trim().length === 0) {
	      e.preventDefault();
	      this.onTagDeleted(this.props.value.length - 1);
	    }
	  },
	
	  handleArrowLeft: function handleArrowLeft() {
	    var result = this.state.selection.item - 1;
	    this.setState({ selection: {
	        category: this.state.selection.category,
	        item: result >= 0 ? result : 0
	      } });
	  },
	
	  handleArrowUp: function handleArrowUp() {
	    var result = this.state.selection.category - 1;
	    this.setState({ selection: {
	        category: result >= 0 ? result : 0,
	        item: 0
	      } });
	  },
	
	  handleArrowRight: function handleArrowRight() {
	    var result = this.state.selection.item + 1;
	    var cat = this.state.categories[this.state.selection.category];
	    this.setState({ selection: {
	        category: this.state.selection.category,
	        item: result <= cat.items.length ? result : cat.items.length
	      } });
	  },
	
	  handleArrowDown: function handleArrowDown() {
	    var result = this.state.selection.category + 1;
	    var cats = this.state.categories;
	    this.setState({ selection: {
	        category: result < cats.length ? result : cats.length - 1,
	        item: 0
	      } });
	  },
	
	  onKeyDown: function onKeyDown(e) {
	    var result = undefined;
	    switch (e.keyCode) {
	      case key.TAB:
	      case key.ENTER:
	        if (!this.state.value) {
	          // enable normal tab/enter behavior
	          // (don't preventDefault)
	          break;
	        }
	      case key.COMMA:
	        e.preventDefault();
	        this.addSelectedTag();
	        break;
	      case key.BACKSPACE:
	        this.handleBackspace(e);
	        break;
	      case key.LEFT:
	        this.handleArrowLeft();
	        break;
	      case key.UP:
	        this.handleArrowUp();
	        break;
	      case key.RIGHT:
	        this.handleArrowRight();
	        break;
	      case key.DOWN:
	        this.handleArrowDown();
	        break;
	    }
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__root' },
	      _react2['default'].createElement(_InputJsx2['default'], { openPanel: this.openPanel, closePanel: this.closePanel,
	        onValueChange: this.onValueChange, onTagDeleted: this.onTagDeleted,
	        onKeyDown: this.onKeyDown, placeholder: this.props.placeholder, value: this.state.value,
	        getTagStyle: this.props.getTagStyle,
	        tags: this.props.value,
	        transformTag: this.props.transformTag,
	        onBlur: this.props.onBlur, ref: 'input' }),
	      this.state.panelOpened && this.state.value.length > 0 ? _react2['default'].createElement(_PanelJsx2['default'], { categories: this.state.categories,
	        selection: this.state.selection, onAdd: this.onAdd,
	        input: this.state.value,
	        getCreateNewText: this.props.getCreateNewText,
	        addNew: this.props.addNew === undefined ? true : this.props.addNew }) : ''
	    );
	  }
	});
	
	exports['default'] = CategorizedTagInput;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TagJsx = __webpack_require__(2);
	
	var _TagJsx2 = _interopRequireDefault(_TagJsx);
	
	var PropTypes = _react2['default'].PropTypes;
	
	var getCreateNewText = function getCreateNewText(title, text) {
	  return 'Create new ' + title + ' "' + text + '"';
	};
	
	var Category = _react2['default'].createClass({
	  displayName: 'Category',
	
	  propTypes: {
	    items: PropTypes.array.isRequired,
	    category: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	    title: PropTypes.string.isRequired,
	    selected: PropTypes.bool.isRequired,
	    selectedItem: PropTypes.number.isRequired,
	    input: PropTypes.string.isRequired,
	    addNew: PropTypes.bool,
	    type: PropTypes.string,
	    onAdd: PropTypes.func.isRequired,
	    single: PropTypes.bool,
	    getTagStyle: PropTypes.func,
	    getCreateNewText: PropTypes.func
	  },
	
	  onAdd: function onAdd(title) {
	    var _this = this;
	
	    return function () {
	      _this.props.onAdd({
	        category: _this.props.category,
	        title: title
	      });
	    };
	  },
	
	  onCreateNew: function onCreateNew(e) {
	    e.preventDefault();
	    this.onAdd(this.props.input)();
	  },
	
	  getTagStyle: function getTagStyle(item) {
	    return this.props.getTagStyle ? this.props.getTagStyle(item) : {};
	  },
	
	  itemToTag: function itemToTag(item, i) {
	    return _react2['default'].createElement(_TagJsx2['default'], { selected: this.isSelected(i),
	      input: this.props.input, text: item, addable: true, deletable: false,
	      onAdd: this.onAdd(item), key: item + '_' + i, style: this.getTagStyle(item) });
	  },
	
	  fullMatchInItems: function fullMatchInItems() {
	    for (var i = 0, len = this.props.items.length; i < len; i++) {
	      if (this.props.items[i] === this.props.input) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  getItems: function getItems() {
	    return {
	      items: this.props.items.map(this.itemToTag),
	      fullMatch: this.fullMatchInItems()
	    };
	  },
	
	  isSelected: function isSelected(i) {
	    return this.props.selected && (i === this.props.selectedItem || this.props.single);
	  },
	
	  getAddBtn: function getAddBtn(fullMatch, selected) {
	    var title = this.props.type || this.props.title;
	    var text = this.props.input;
	    var getText = this.props.getCreateNewText || getCreateNewText;
	    if (this.props.addNew && !fullMatch && !this.props.single) {
	      return [this.props.items.length > 0 ? _react2['default'].createElement(
	        'span',
	        { key: 'cat_or', className: 'cti__category__or' },
	        'or'
	      ) : null, _react2['default'].createElement(
	        'button',
	        {
	          key: 'add_btn',
	          className: 'cti__category__add-item' + (selected ? ' cti-selected' : ''),
	          onClick: this.onCreateNew
	        },
	        getText(title, text)
	      )];
	    }
	
	    return null;
	  },
	
	  render: function render() {
	    var _getItems = this.getItems();
	
	    var items = _getItems.items;
	    var fullMatch = _getItems.fullMatch;
	
	    var addBtn = this.getAddBtn(fullMatch, (items.length === 0 || this.props.selectedItem >= items.length) && this.props.selected);
	
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__category' },
	      _react2['default'].createElement(
	        'h5',
	        { className: 'cti__category__title' },
	        this.props.title
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: 'cti__category__tags' },
	        items,
	        addBtn
	      )
	    );
	  }
	});
	
	exports['default'] = Category;
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TagJsx = __webpack_require__(2);
	
	var _TagJsx2 = _interopRequireDefault(_TagJsx);
	
	var PropTypes = _react2['default'].PropTypes;
	
	var Input = _react2['default'].createClass({
	  displayName: 'Input',
	
	  propTypes: {
	    openPanel: PropTypes.func.isRequired,
	    closePanel: PropTypes.func.isRequired,
	    onValueChange: PropTypes.func.isRequired,
	    onTagDeleted: PropTypes.func.isRequired,
	    onKeyDown: PropTypes.func.isRequired,
	    value: PropTypes.string.isRequired,
	    tags: PropTypes.arrayOf(PropTypes.object).isRequired,
	    placeholder: PropTypes.string,
	    onBlur: PropTypes.func,
	    getTagStyle: PropTypes.func,
	    transformTag: PropTypes.func
	  },
	
	  focusInput: function focusInput() {
	    this.refs.input.focus();
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      getTagStyle: function getTagStyle(tag) {
	        // empty style object by default
	        return {};
	      },
	      transformTag: function transformTag(tag) {
	        return tag.title;
	      }
	    };
	  },
	
	  getTags: function getTags() {
	    var _this = this;
	
	    return this.props.tags.map(function (tag, i) {
	      return _react2['default'].createElement(_TagJsx2['default'], { selected: false, input: '', text: _this.props.transformTag(tag), addable: false,
	        deletable: true, key: tag.title + '_' + i,
	        onDelete: function () {
	          return _this.props.onTagDeleted(i);
	        },
	        style: _this.props.getTagStyle(tag) });
	    });
	  },
	
	  onBlur: function onBlur(e) {
	    this.props.closePanel();
	    if (typeof this.props.onBlur === 'function') {
	      this.props.onBlur(e);
	    }
	  },
	
	  render: function render() {
	    var placeholder = this.props.placeholder || '';
	    var size = this.props.value.length === 0 ? placeholder.length : this.props.value.length;
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__input', onClick: this.focusInput },
	      this.getTags(),
	      _react2['default'].createElement('input', { type: 'text', ref: 'input', value: this.props.value,
	        size: size + 2,
	        onFocus: this.props.openPanel, onBlur: this.onBlur,
	        onChange: this.props.onValueChange, onKeyDown: this.props.onKeyDown,
	        placeholder: placeholder, 'aria-label': placeholder,
	        className: 'cti__input__input' }),
	      _react2['default'].createElement('div', { className: 'cti__input__arrow' })
	    );
	  }
	});
	
	exports['default'] = Input;
	module.exports = exports['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CategoryJsx = __webpack_require__(4);
	
	var _CategoryJsx2 = _interopRequireDefault(_CategoryJsx);
	
	var PropTypes = _react2['default'].PropTypes;
	
	var Panel = _react2['default'].createClass({
	  displayName: 'Panel',
	
	  propTypes: {
	    categories: PropTypes.arrayOf(PropTypes.object).isRequired,
	    selection: PropTypes.object.isRequired,
	    onAdd: PropTypes.func.isRequired,
	    input: PropTypes.string.isRequired,
	    addNew: PropTypes.bool,
	    getTagStyle: PropTypes.func,
	    getCreateNewText: PropTypes.func
	  },
	
	  getCategories: function getCategories() {
	    var _this = this;
	
	    return this.props.categories.map(function (c, i) {
	      return _react2['default'].createElement(_CategoryJsx2['default'], { key: c.id, items: c.items, category: c.id, title: c.title,
	        selected: _this.props.selection.category === i,
	        selectedItem: _this.props.selection.item,
	        input: _this.props.input, addNew: _this.props.addNew,
	        type: c.type, onAdd: _this.props.onAdd, single: c.single,
	        getTagStyle: _this.props.getTagStyle,
	        getCreateNewText: _this.props.getCreateNewText });
	    });
	  },
	
	  render: function render() {
	    return _react2['default'].createElement(
	      'div',
	      { className: 'cti__panel' },
	      this.getCategories()
	    );
	  }
	});
	
	exports['default'] = Panel;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TAB = 9;
	exports.TAB = TAB;
	var ENTER = 13;
	exports.ENTER = ENTER;
	var BACKSPACE = 8;
	exports.BACKSPACE = BACKSPACE;
	var LEFT = 37;
	exports.LEFT = LEFT;
	var UP = 38;
	exports.UP = UP;
	var RIGHT = 39;
	exports.RIGHT = RIGHT;
	var DOWN = 40;
	exports.DOWN = DOWN;
	var COMMA = 188;
	exports.COMMA = COMMA;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** categorized-tag-input.js
 **/